<template>
  <v-app-bar
    app
    color="white"
    flat
    height="100"
    class="container pl-0 pr-0 pb-0 main-header"
  >
    <div class="media-exit__orderer__logo-image">
      <router-link to="/">
        <img
          src="../../assets/images/Media_Exit_0419.png"
          alt="media-exit__orderer"
      /></router-link>
    </div>
    <!-- Hamberger Menu -->
    <v-spacer></v-spacer>
    <v-toolbar-title style="font-size: 16px; margin-top: -8px"
      >Hi, {{ userName }}</v-toolbar-title
    >
    <div class="media-exit-menu-bar">
      <div ref="HamburgerButton" @click="showmenu = !showmenu">
        <span ref="HamburgerButton" v-if="!showmenu" class="menu"></span>
        <span ref="HamburgerButton" v-else class="close-menu"></span>
      </div>
      <v-list
        v-show="showmenu"
        v-closable="{
          exclude: ['HamburgerButton'],
          handler: 'onClose'
        }"
        class="media-exit-menu"
      >
        <div v-if="isOrder">
          <v-list-item-content>
            <v-list-item-title
              class="pr-1 media-exit-list-title cursor-pointer"
              @click="goToAdmin"
              >Administrator</v-list-item-title
            >
          </v-list-item-content>
          <v-list-item-content>
            <v-list-item-title
              class="pr-1 media-exit-list-title cursor-pointer"
              @click="goToUserGroup"
              >User Groups</v-list-item-title
            >
          </v-list-item-content>
        </div>
        <div v-if="isAdmin">
          <v-list-item-content>
            <v-list-item-title
              class="pr-1 media-exit-list-title cursor-pointer"
              @click="goToOrderer"
              >Orderer</v-list-item-title
            >
          </v-list-item-content>
          <v-list-item-content>
            <v-list-item-title
              class="pr-1 media-exit-list-title cursor-pointer"
              @click="goToUserGroup"
              >User Groups</v-list-item-title
            >
          </v-list-item-content>
        </div>
        <div v-if="isUserGroup">
          <v-list-item-content>
            <v-list-item-title
              class="pr-1 media-exit-list-title cursor-pointer"
              @click="goToAdmin"
              >Administrator</v-list-item-title
            >
          </v-list-item-content>
          <v-list-item-content>
            <v-list-item-title
              class="pr-1 media-exit-list-title cursor-pointer"
              @click="goToOrderer"
              >Orderer</v-list-item-title
            >
          </v-list-item-content>
        </div>
        <v-list-item-content>
          <v-list-item-title
            class="pr-1 media-exit-list-title cursor-pointer"
            @click="logout"
            >Logout</v-list-item-title
          >
        </v-list-item-content>
      </v-list>
    </div>
  </v-app-bar>
</template>
<script>
import Vue from "vue";
let handleOutsideClick;

Vue.directive("closable", {
  bind(el, binding, vnode) {
    handleOutsideClick = e => {
      e.stopPropagation();
      const { handler, exclude } = binding.value;

      let clickedOnExcludedEl = false;
      exclude.forEach(refName => {
        if (!clickedOnExcludedEl) {
          const excludedEl = vnode.context.$refs[refName];
          if (excludedEl) {
            clickedOnExcludedEl = excludedEl.contains(e.target);
          } else {
            clickedOnExcludedEl = false;
          }
        }
      });

      if (!el.contains(e.target) && !clickedOnExcludedEl) {
        vnode.context[handler]();
      }
    };
    document.addEventListener("click", handleOutsideClick);
    document.addEventListener("touchstart", handleOutsideClick);
  }
});
export default {
  data: () => ({
    showmenu: false,
    group: null,
    userName: "",
    isAdmin: false,
    isUserGroup: false,
    isOrder: false
  }),
  methods: {
    onClose() {
      this.showmenu = false;
    },
    logout() {
      const vm = this;
        const logout = "api/logout/";
        vm.$apiService
          .getData("post", `${logout}`, {}, {}, null, {})
          .then(data => {
            console.log(data)
             let Okta_Preview_url = "https://aenetworks.oktapreview.com/app/UserHome"
              window.sessionStorage.clear();
              window.localStorage.clear();
              window.location.href = Okta_Preview_url;
          })

    },
    goToAdmin() {
      if (this.$route.path === "/user-group/edit-user-group") {
        this.$router.replace({ path: "/admin" });
      } else if (this.$route.path === "/user-group/new-user-group") {
        this.$router.replace({ path: "/admin" });
      } else {
        this.$router.push("admin");
      }
    },
    goToUserGroup() {
      this.$router.push("user-group");
    },
    goToOrderer() {
      this.$router.push("/");
    }
  },
  mounted() {
    const vm = this;
    if (this.$route.path === "/admin") {
      this.isAdmin = true;
    } else if (this.$route.path === "/") {
      this.isOrder = true;
    } else if (this.$route.path === "/user-group") {
      this.isUserGroup = true;
    } else if (this.$route.path === "/user-group/edit-user-group") {
      this.isUserGroup = true;
    } else if (this.$route.path === "/user-group/new-user-group") {
      this.isUserGroup = true;
    }
    const domainUrl = "api/userdata/";
    vm.$apiService
      .getData("get", `${domainUrl}`, {}, {}, null, {})
      .then(data => {
        this.userName = data.data.first_name;
      });
  },
  watch: {
    $route() {
      if (this.$route.path === "/admin") {
        this.adminOption = "Orderer";
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "Header";
</style>

<style lang="scss">
@import "Header_unscoped.scss";
</style>
